import * as styles from 'styles/molecules/forms/Form.css'
import { CONTACT_EMAIL_HINT } from 'constants/hints'
import { onFormSubmit } from 'helpers/formHelpers'
import { formatPhone } from 'helpers/formatHelpers'
import ContactEditForm from 'components/molecules/forms/ContactEditForm'
import DescriptionList, { DescriptionItemType } from 'components/atoms/DescriptionList'
import ButtonRow from 'components/atoms/buttons/ButtonRow'
import { showContactEditFormActionCreator } from 'actions/settingsActions'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import OptOutModalContainer from 'components/features/pfm/OptOutModal/OptOutModalContainer'

export type ContactSettingsModuleStateProps = {
  email: string
  contact_email: string
  phone: string
  contactEditFormVisible: boolean
}

export type ContactSettingsModuleDispatchProps = {
  showContactEditForm: typeof showContactEditFormActionCreator
}

type ContactSettingsModuleProps = ContactSettingsModuleStateProps & ContactSettingsModuleDispatchProps

const ContactSettingsModule = (props: ContactSettingsModuleProps) => {
  const {
    email,
    contact_email,
    phone,
    contactEditFormVisible,
    showContactEditForm,
  } = props

  const memberInfo = useStoreSelector(memberInfoSelector)

  const listItems: DescriptionItemType[] = [
    {
      label: 'E-mail Address',
      value: contact_email || email || null,
      hint: CONTACT_EMAIL_HINT,
      qaMarker: 'email',
    }, {
      label: 'Mobile Phone Number',
      value: phone ? formatPhone(phone) : null,
      qaMarker: 'phone-number',
    },
  ]

  return contactEditFormVisible ? (
    <ContactEditForm
      initialValues={{
        contact_email: contact_email ? contact_email : email,
        phone: phone ? phone.replace('+1', '') : '',
      }}
      onSubmit={ onFormSubmit }
      onCancel={ () => showContactEditForm(false) }
    />
  ) : (
    <div className={ styles.form }>
      <DescriptionList items={ listItems } />
      <ButtonRow
        size='small'
        buttonsPerRow={ 2 }
        buttons={ [
          { text: 'Edit', qaMarker: 'edit-button', onClick: () => showContactEditForm(true) },
        ] }
      />
      { !!memberInfo?.has_active_ledger && <OptOutModalContainer /> }
    </div>
  )
}

export default ContactSettingsModule
